import React from "react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import "./TopBanner.css";
import hello from "../../../Assets/Hello.jpg";
import html from "../../../Assets/html-5.png";
import css from "../../../Assets/css-3.png";
import tailwind from "../../../Assets/tailwind-css-icon.png";
import materialUI from "../../../Assets/material-ui.png";
import bootstrap from "../../../Assets/bootstrap.png";
import javaScript from "../../../Assets/js.png";
import typeScript from "../../../Assets/typescript.png";
import react from "../../../Assets/react.png";
import redux from "../../../Assets/redux.png";
import next from "../../../Assets/next.png";
import node from "../../../Assets/nodejs.png";
import express from "../../../Assets/express.png";
import mongodb from "../../../Assets/mongodb.png";
import mysql from "../../../Assets/mysql.png";
import cSharp from "../../../Assets/c-sharp.png";
import unity from "../../../Assets/unity.png";
import Tech from "./Tech";

const TopBanner = () => {
  const techStack = [
    {
      name: "HTML5",
      image: html,
    },
    {
      name: "CSS3",
      image: css,
    },
    {
      name: "Tailwind",
      image: tailwind,
    },
    {
      name: "Bootstrap",
      image: bootstrap,
    },
    {
      name: "MaterialUI",
      image: materialUI,
    },
    {
      name: "JavaScript",
      image: javaScript,
    },
    {
      name: "TypeScript",
      image: typeScript,
    },
    {
      name: "C#",
      image: cSharp,
    },
    {
      name: "React",
      image: react,
    },
    {
      name: "Redux",
      image: redux,
    },
    {
      name: "Next.js",
      image: next,
    },
    {
      name: "Node.js",
      image: node,
    },
    {
      name: "Express.js",
      image: express,
    },
    {
      name: "MongoDB",
      image: mongodb,
    },
    {
      name: "MySQL",
      image: mysql,
    },
    {
      name: "Unity",
      image: unity,
    },
  ];

  return (
    <div id="home" className="bg-[#F9F9F9] lg:h-screen md:h-screen">
      <div className="h-full lg:pt-16 md:pt-10 lg:w-[65%] md:w-[85%] mx-auto pb-10 lg:pb-0 md:pb-0">
        <div className="flex lg:flex-row md:flex-row flex-col-reverse lg:gap-x-10 w-full">
          <div className="flex flex-col justify-center gap-y-10 lg:w-3/5">
            <h1 className="font-poppins lg:text-5xl md:text-4xl text-3xl lg:text-start md:text-start text-center font-extrabold tracking-wider text-gray-dark flex flex-col gap-2 lg:mt-0 md:mt-0 mt-5">
              Full-Stack Web
              <br />
              <div className="flex items-center lg:justify-start md:justify-start justify-center gap-x-4">
                Developer
                <img
                  src={hello}
                  className="lg:w-14 w-7 animate-pulse"
                  alt="Hello"
                />
              </div>
            </h1>
            <h4 className="font-mulish text-[18px] text-[#76768B] leading-7 font-medium tracking-wide lg:text-start md:text-start text-center">
              Hi, I'm <span className="font-semibold">Khubaibul Islam.</span> A
              passionate <br />
              <span className="font-semibold">
                Full-Stack Web Developer
              </span> & <span className="font-semibold">a student</span> based
              in{" "}
              <span className="font-semibold text-[#0033A0] text-xl italic">
                Moscow,
              </span>
              <span className="font-semibold text-[#DA291C] ml-1 text-xl italic">
                Russia.
              </span>{" "}
              🍭
            </h4>
            <div className="flex gap-x-3 lg:justify-start md:justify-start justify-center">
              <a
                href="https://www.linkedin.com/in/khubaibul-islam"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin className="text-[#2D2E32] hover:text-blue text-3xl transition-all duration-300" />
              </a>
              <a
                href="https://github.com/khubaibul"
                target="_blank"
                rel="noreferrer"
              >
                <FaGithub className="text-[#2D2E32] hover:text-blue text-3xl transition-all duration-300" />
              </a>
            </div>
          </div>
          <div className="blob lg:w-[350px] lg:h-[350px] md:w-[320px] md:h-[320px] w-[280px] h-[280px]"></div>
        </div>
        <div className="mt-36 flex items-center lg:gap-x-10 md:gap-x-5 gap-x-2 lg:pl-0 md:pl-0 sm:pl-8 pl-2">
          <div className="font-mulish font-extrabold tracking-wide lg:text-lg md:text-lg text-blue text-xs flex items-center">
            <h2>Tech Stack</h2>
            <span className="ml-4 text-gray-dark lg:flex md:block hidden">
              |
            </span>
          </div>
          <div className="flex lg:gap-x-3 md:gap-x-3 sm:gap-x-3 gap-x-2 gap-y-2 flex-wrap">
            {techStack?.map((tech, i) => (
              <Tech key={i} tech={tech} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
